<template>
  <v-container class="no-margins">
    <ActionButton
      class="mt-4" 
      actionIcon="$sl-password-type" 
      href="https://byn2.byn.se/sign_in"
    >
      {{ $t('labels.login-byn2') }}
    </ActionButton>
  </v-container>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton'

export default {
  name: 'Byn2LoginButton',

  components: {
    ActionButton
  }
}
</script>

<style scoped>
</style>